import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';

// Suppress benign ResizeObserver error from MUI, react-indiana-drag-scroll and other libs during window resize
const resizeObserverErrMsg = 'ResizeObserver loop';
const hideResizeObserverOverlay = () => {
  requestAnimationFrame(() => {
    const overlay = document.getElementById(
      'webpack-dev-server-client-overlay',
    );
    if (overlay) overlay.style.display = 'none';
  });
};
window.addEventListener(
  'error',
  (e) => {
    if (e.message?.includes?.(resizeObserverErrMsg)) {
      e.stopImmediatePropagation();
      hideResizeObserverOverlay();
    }
  },
  true,
);
const prevOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (typeof message === 'string' && message.includes(resizeObserverErrMsg)) {
    hideResizeObserverOverlay();
    return true;
  }
  return prevOnError
    ? prevOnError(message, source, lineno, colno, error)
    : false;
};
// import reportWebVitals from './reportWebVitals';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
